import React from 'react'
import styled from 'styled-components'
import Loader from 'react-loader-spinner'
import Page from './layouts/Page'

const Wrapper = styled(Page)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  p {
    transform: translateX(-55px);
    text-align: center; 
    font-size: 11px;
  }
`

const PageLoader: React.FC = () => {
  return (
    <Wrapper>
      <Loader type='Grid' color='#252525' height={55} width={55} />
    </Wrapper>
  )
}

export default PageLoader
